import { render, staticRenderFns } from "./taskSummary.vue?vue&type=template&id=0fbb358a&scoped=true"
import script from "./taskSummary.vue?vue&type=script&lang=js"
export * from "./taskSummary.vue?vue&type=script&lang=js"
import style0 from "./taskSummary.vue?vue&type=style&index=0&id=0fbb358a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb358a",
  null
  
)

export default component.exports